import { ComponentCanDeactivate } from './can-deactivate/component-can-deactivate';
import { NgForm } from "@angular/forms";

export abstract class FormCanDeactivate extends ComponentCanDeactivate {

  abstract get form(): NgForm;
  abstract get pr(): NgForm;

  canDeactivate(): boolean {
    if(window.localStorage['jwtToken']){
    if (this.form.value.startDate1) {
      if (this.form.dirty) {
        return false
      }
    }
    if (this.pr) {
      if (this.form.dirty)
        return this.form.submitted || !this.form.dirty
      else
        return this.pr.submitted || !this.pr.dirty
    }
    return this.form.submitted || !this.form.dirty
  }else
    return true
  }
}